export const BASE_URL = process.env.REACT_APP_API_URL || 'https://rss-kanban-rest.onrender.com';
export const GITHUB_LINKS = {
  artpotlov: 'https://github.com/artpotlov',
  tonKristall: 'https://github.com/tonKristall',
  slavaShchipunov: 'https://github.com/Slava-Shchipunov',
};

export const keysLS = {
  userData: 'userData',
};

export const DRAGGABLE_TYPES = {
  column: 'column',
  task: 'task',
};
